import React from 'react';

/**
 * LoadingState - Centered loading indicator
 */
export function LoadingState({ message = 'Loading...' }) {
  return (
    <div className="loading-state">
      <div className="spinner"></div>
      <p>{message}</p>
    </div>
  );
}

/**
 * EmptyState - Empty state with icon and message
 */
export function EmptyState({ icon: Icon, title, message, action }) {
  return (
    <div className="empty-state">
      {Icon && <Icon size={48} />}
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {action}
    </div>
  );
}

/**
 * StatusBadge - Styled status indicator
 */
export function StatusBadge({ status, children }) {
  return (
    <span className={`status-badge ${status}`}>
      {children}
    </span>
  );
}

/**
 * RoleBadge - Styled role indicator
 */
export function RoleBadge({ role, children }) {
  return (
    <span className={`role-badge ${role}`}>
      {children}
    </span>
  );
}

/**
 * UserAvatar - User avatar with initials or image
 */
export function UserAvatar({ firstName, lastName, image, size = 'medium', className = '' }) {
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  const sizeClass = size === 'small' ? 'user-avatar-small' : 
                    size === 'large' ? 'user-avatar-large' : 'user-avatar';

  if (image) {
    return <img src={image} alt={`${firstName} ${lastName}`} className={`${sizeClass} ${className}`} />;
  }

  return (
    <div className={`${sizeClass} ${className}`}>
      {initials}
    </div>
  );
}

/**
 * Message - Alert/notification message
 */
export function Message({ type, children }) {
  if (!children) return null;
  return (
    <div className={`message message-${type}`}>
      {children}
    </div>
  );
}
